import React from "react";

export default function ProjectForm({
  handleSubmit,
  heading,
  value,
  setValue,
  setShowModal,
  confirmButtonText,
}) {
  return (
    <div className="ProjectForm">
      <form onSubmit={handleSubmit}>
        <h3>{heading}</h3>
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="project name..."
          autoFocus
        />
        <button
          className="cancel"
          role="button"
          onClick={() => setShowModal(false)}
        >
          cancel
        </button>
        <button className="confirm">{confirmButtonText}</button>
      </form>
    </div>
  );
}
